import { getUserStops, hasMultipleCollectionsOrDeliveries } from 'helpers/waitAndReturn.helpers'

export const isAddressPopulated = (
  address: any,
  addressDefaultFields: string[],
  defaultValue: string,
) => {
  return addressDefaultFields.every((field) => address[field] !== defaultValue)
}

export const isCollectionAndDeliveryAddressPopulated = (
  collectionAddresses: any[],
  deliveryAddresses: any[],
) => {
  const defaultValue = ''
  const addressDefaultFields = ['name', 'addressLine1', 'city', 'postcode', 'country']
  const userCollections = getUserStops(collectionAddresses)
  const userDeliveries = getUserStops(deliveryAddresses)

  if (userCollections.length > 0 && userDeliveries.length > 0) {
    return (
      isAddressPopulated(userCollections[0], addressDefaultFields, defaultValue) &&
      isAddressPopulated(userDeliveries[0], addressDefaultFields, defaultValue)
    )
  }

  return false
}

export const getWaitAndReturnTooltipText = (
  collectionAddresses: any[],
  deliveryAddresses: any[],
  customerId?: string,
) => {
  if (!customerId) {
    return 'A customer must be selected to enable "Wait and Return" option.'
  }

  if (hasMultipleCollectionsOrDeliveries(collectionAddresses, deliveryAddresses)) {
    return 'The booking has more than one Collection or Delivery Address. "Wait and Return" is for there-and-back journeys and cannot be selected.'
  }

  if (!isCollectionAndDeliveryAddressPopulated(collectionAddresses, deliveryAddresses)) {
    return 'Both Collection and Delivery addresses mandatory fields must be populated to enable "Wait and Return" option.'
  }

  return 'This checkbox adds Wait & Return charges for jobs requiring a return journey.'
}
